<template>
	<article class="fed-os">
		<h1>Front End Outsourcing</h1>
		<div class="content">
			<p>
				While you focus on your core business process, our expert web developers will maximize your ability to deliver high quality product and speed up time-to-market.
			</p>

			<!-- ================================================= -->
			<!-- Why a Website is a worthwhile business investment -->
			<!-- ================================================= -->
			<h3 @click="toggleCollapse('collapseA')" class="collapse-link">
				<span class="glyphicon glyphicon-chevron-right" v-show="!collapseA"></span>
				<span class="glyphicon glyphicon-chevron-down" v-show="collapseA"></span>
				Why outsource your web development
			</h3>
			<div v-show="collapseA" class="collapse-container">
				<ul class="media-list icon-list">
					<li class="media media-success media-default">
						<div class="media-left">
							<a class="btn btn-success btn-lg btn-circle">
								<span class="glyphicon glyphicon-euro"></span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Cost Savings.</h4>

						</div>
					</li>
					<li class="media media-success media-default">
						<div class="media-left">
							<a class="btn btn-success btn-lg btn-circle">
								<span class="glyphicon glyphicon-hourglass"></span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Time Savings.</h4>
						</div>
					</li>
					<li class="media media-success media-default">
						<div class="media-left">
							<a class="btn btn-success btn-lg btn-circle">
								<span class="glyphicon glyphicon-resize-horizontal"></span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Flexibility.</h4>
						</div>
					</li>
					<li class="media media-success media-default">
						<div class="media-left">
							<a class="btn btn-success btn-lg btn-circle">
								<span class="glyphicon glyphicon-record"></span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Focused Strategy.</h4>
						</div>
					</li>
					<li class="media media-success media-default">
						<div class="media-left">
							<a class="btn btn-success btn-lg btn-circle">
								<span class="glyphicon glyphicon-ok"></span>
							</a>
						</div>
						<div class="media-body">
							<h4 class="media-heading">Lack of in house experience.</h4>
						</div>
					</li>
				</ul>
				<div class="spacing10"></div>
				<p>
					Outsourcing web development makes a lot of sense in order to maximize your profits in a small amount of time.
				</p>
				<div class="spacing30"></div>
			</div>

		</div>

	</article>
</template>

<script>
	export default {
		name: 'frontEndOutsourcing',
		methods: {
			toggleCollapse (collapse) {
				if (collapse) {
					this[collapse] = !this[collapse]
				}
			}
		},
		data () {
			return {
				collapseA: false
			}
		}
	}
</script>

<style scoped>
	.fed-os .content h3 { cursor:pointer; }
	.fed-os .media-list .media { padding:15px; background: #e5e5e5; }
	.fed-os .media-list .media-left { padding-right:15px; border-right:2px solid #ccc; }
	.fed-os .media-list .media-left .btn { position:relative; width:40px; height:40px; }
	.fed-os-dev .media-list .media-left .btn .customicon,
	.fed-os .media-list .media-left .btn .glyphicon { position:absolute; top:50%; left:50%; transform: translate(-50%, -50%); font-size: 20px; }
	.fed-os .media-list .media-body { padding-left:15px; }
	.fed-os .media-list .media-heading { margin:10px 0; }
</style>



// WEBPACK FOOTER //
// front-end-outsourcing.vue?ec0da362